export const multiselect = {
  css: ({ dt }: any) => `
    .p-multiselect {
        box-shadow: none;
        border-radius: 1rem;
        border: 1px solid rgb(226 232 240 / var(--tw-border-opacity, 1));
        height: 3rem;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 0.5rem;
    }

    .p-multiselect-overlay {
        border-radius: 1rem;
        border: 1px solid rgb(226 232 240 / var(--tw-border-opacity, 1));
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }
    `,
};
